module.exports = __webpack_public_path__ + "img/power-act-bg-1.76de1a56.png";